import { NextPageContext } from "next";

import { BaseInitialProps } from "src/utilities/ssr/baseInitialProps";
import { addCacheControl } from "src/utilities/ssr/caching";
import { validateAndDecodeParam } from "src/utilities/ssr/validateAndDecodeParam";

export const getUserInitialProps =
  (getUserProps?: (slug: string) => Promise<BaseInitialProps>) =>
  async (ctx: NextPageContext) => {
    const username = validateAndDecodeParam(ctx, "username", "/@:username");
    const props = { username };

    // Not on server, do nothing - let client-side data fetching handle this
    if (!ctx.res) {
      return props;
    }

    // Cache this SSR response at edge
    addCacheControl(ctx);

    if (!getUserProps) {
      return props;
    }

    try {
      const data = await getUserProps(username);
      return { ...props, ...data };
    } catch (error) {
      ctx.res.statusCode = 404;
      return props;
    }
  };
